export type ParsedAiSummary = {
    summary: string;
    nextStep: string | null;
};

const SUMMARY_HEADER_RE = /^\s*summary\s*:?\s*/i;
const NEXT_STEP_HEADER_RE =
    /^\s*(?:recommended\s+next\s+step|next\s+step|next)\s*:?\s*/i;

/**
 * Splits an AI summarize response into Summary + Recommended next step.
 * Falls back to the full text as summary when section markers are missing.
 */
export function parseAiSummaryResponse(raw: string): ParsedAiSummary {
    const text = (raw ?? '').trim();
    if (!text) {
        return { summary: '', nextStep: null };
    }

    const nextStepMatch = text.match(
        /\n\s*(?:Recommended\s+next\s+step|Next\s+step|NEXT)\s*:?\s*/i,
    );

    if (nextStepMatch && nextStepMatch.index !== undefined) {
        const summaryPart = text.slice(0, nextStepMatch.index).trim();
        const nextPart = text.slice(nextStepMatch.index + nextStepMatch[0].length).trim();

        return {
            summary: summaryPart.replace(SUMMARY_HEADER_RE, '').trim() || summaryPart,
            nextStep: nextPart.replace(NEXT_STEP_HEADER_RE, '').trim() || null,
        };
    }

    // Single-line / inline "Recommended next step:" without a leading newline
    const inlineMatch = text.match(
        /\b(?:Recommended\s+next\s+step|Next\s+step)\s*:\s*/i,
    );
    if (inlineMatch && inlineMatch.index !== undefined && inlineMatch.index > 0) {
        const summaryPart = text.slice(0, inlineMatch.index).trim();
        const nextPart = text.slice(inlineMatch.index + inlineMatch[0].length).trim();
        return {
            summary: summaryPart.replace(SUMMARY_HEADER_RE, '').trim() || summaryPart,
            nextStep: nextPart || null,
        };
    }

    return {
        summary: text.replace(SUMMARY_HEADER_RE, '').trim() || text,
        nextStep: null,
    };
}
